export function entityProfileHref(
  entityType: string | null | undefined,
  entityId: string | null | undefined
): string | null {
  if (!entityType || !entityId) return null
  if (entityType === 'company') return `/company/${entityId}`
  if (entityType === 'person') return `/person/${entityId}`
  return null
}

export function activityEntityLabel(
  meta: Record<string, unknown> | null
): string | null {
  if (!meta) return null
  const name = meta.displayName
  return typeof name === 'string' && name.trim() !== '' ? name : null
}

export function activityEntityHref(
  meta: Record<string, unknown> | null
): string | null {
  if (!meta) return null
  const entityType =
    typeof meta.entityType === 'string' ? meta.entityType : null
  const entityId = typeof meta.entityId === 'string' ? meta.entityId : null
  return entityProfileHref(entityType, entityId)
}

export function activityListName(
  meta: Record<string, unknown> | null
): string | null {
  if (!meta) return null
  const name = meta.listName
  return typeof name === 'string' && name.trim() !== '' ? name : null
}

export function watchlistAddSummarySuffix(listName: string): string {
  return ` til watchlist ${listName}`
}

export function splitSummaryAroundEntity(
  summary: string,
  entityName: string
): { before: string; after: string } | null {
  const idx = summary.indexOf(entityName)
  if (idx < 0) return null
  return {
    before: summary.slice(0, idx),
    after: summary.slice(idx + entityName.length),
  }
}
